import { render, staticRenderFns } from "./modal-educare-terms-and-conditions.vue?vue&type=template&id=0c6e13eb"
import script from "./modal-educare-terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./modal-educare-terms-and-conditions.vue?vue&type=script&lang=js"
import style0 from "./modal-educare-terms-and-conditions.vue?vue&type=style&index=0&id=0c6e13eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports